import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es discreto?',
  a: 'Absolutamente. El manual se descarga de forma privada y los ejercicios se pueden realizar sin que nadie lo note.'
}, {
  q: '¿Funciona para hombres mayores?',
  a: 'Sí, el mecanismo de óxido nítrico responde a cualquier edad siempre que haya flujo sanguíneo.'
}, {
  q: '¿Tengo que comprar suplementos adicionales?',
  a: 'No. Todo lo necesario es tu propio cuerpo y, si acaso, un par de alimentos básicos que ya están en tu mercado local.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-slate-900 border-y border-slate-800" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-50">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full" data-id="element-51"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-52">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-slate-950 border border-slate-800 rounded-2xl overflow-hidden" data-id="element-53">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-54">
                <span className="font-semibold text-lg text-slate-200" data-id="element-55">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-blue-500 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-56" />
              </button>
              <AnimatePresence data-id="element-57">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-58">
                    <div className="px-6 pb-5 text-slate-400 leading-relaxed" data-id="element-59">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}